import React, { CSSProperties, Suspense } from 'react'
import Field from '../fields'
import { capitalize } from 'lodash'

interface CarePlanSectionContentProps {
  fields?: object
  keys?: string | string[]
  formId?: string | null
  value?: string | null
}

const CarePlanSectionContent: React.FC<CarePlanSectionContentProps> = ({
  fields,
  keys,
  formId,
  value,
}) => {
  if (formId) {
    return (
      <div style={styles.formField}>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            className="lmc-card-edit"
            keys={keys}
            // @ts-ignore
            label={capitalize(keys)}
            layout="no-label"
            formId={formId}
            style={styles.input}
            type="textarea"
            values={fields}
          />
        </Suspense>
      </div>
    )
  }

  return (
    <div
      style={styles.text as CSSProperties}
      className={value ? 'lmc-card' : ''}
    >
      {value}
    </div>
  )
}

const styles = {
  formField: {
    display: 'flex',
  },
  input: {
    marginTop: 15,
    minHeight: 100,
    padding: '15px 25px 18px 25px',
    resize: 'vertical',
  },
  text: {
    paddingTop: 15,
    margin: '5px 0px 10px 0px',
    whiteSpace: 'pre-wrap',
  },
}

export default CarePlanSectionContent
